
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --outline-button--family--computed:var(
    --outline-button--family,
    var(--ff-bold)
  );
  --outline-button--weight--computed:var(
    --outline-button--weight,
    var(--fw-extrabold)
  );
  --outline-button--padding--computed:var(
    --outline-button--padding,
    var(--spacing-2) var(--spacing-8)
  );
  --outline-button--radius--computed:var(--outline-button--radius, 0.4rem);
}

:host{
  --outline-button--link-padding--computed:var(
    --outline-button--link-padding,
    var(--spacing-1) var(--spacing-2)
  );
  --outline-button--link-font-size--computed:var(
    --outline-button--link-radius,
    var(--fs-lg)
  );
  --outline-button--link-bg-color--computed:var(
    --outline-button--link-bg-color,
    var(--outline-transparent)
  );
  --outline-button--link-color--computed:var(
    --outline-button--link-color,
    brand var(--brand-dark-blue-900)
  );
  --outline-button--link-disabled-bg-color--computed:var(
    --outline-button--link-disabled-bg-color,
    var(--outline-transparent)
  );
  --outline-button--link-disabled-color--computed:var(
    --outline-button--link-disabled-color,
    var(--brand-gray-600)
  );
  --outline-button--link-disabled-weight--computed:var(
    --outline-button--link-disabled-weight,
    var(--fw-bold)
  );
}

:host{
  --outline-button--primary-padding--computed:var(
    --outline-button--primary-padding,
    var(--outline-button--padding--computed)
  );
  --outline-button--primary-radius--computed:var(
    --outline-button--primary-radius,
    var(--outline-button--radius--computed)
  );
  --outline-button--primary-bg-color--computed:var(
    --outline-button--primary-bg-color,
    var(--brand-bright-blue-900)
  );
  --outline-button--primary-color--computed:var(
    --outline-button--primary-color,
    var(--brand-dark-blue-900)
  );
  --outline-button--primary-weight--computed:var(
    --outline-button--primary-weight,
    var(--outline-button--weight--computed)
  );
  --outline-button--primary-bg-color-focus--computed:var(
    --outline-button--primary-bg-color-focus,
    var(--brand-bright-blue-900)
  );
  --outline-button--primary-color-focus--computed:var(
    --outline-button--primary-color-focus,
    var(--brand-dark-blue-900)
  );
  --outline-button--primary-weight-focus--computed:var(
    --outline-button--primary-weight-focus,
    var(--outline-button--weight--computed)
  );
  --outline-button--primary-ring-focus--computed:var(
    --outline-button--primary-ring-focus,
    var(--outline-ring-offset-width) solid var(--brand-dark-blue-900)
  );
  --outline-button--primary-disabled-bg-color--computed:var(
    --outline-button--primary-disabled-bg-color,
    var(--brand-gray-300)
  );
  --outline-button--primary-disabled-color--computed:var(
    --outline-button--primary-disabled-color,
    var(--brand-gray-600)
  );
  --outline-button--primary-disabled-weight--computed:var(
    --outline-button--primary-disabled-weight,
    var(--outline-button--weight--computed)
  );
}

:host{
  --outline-button--secondary-padding--computed:var(
    --outline-button--secondary-padding,
    var(--outline-button--padding--computed)
  );
  --outline-button--secondary-radius--computed:var(
    --outline-button--secondary-radius,
    var(--outline-button--radius--computed)
  );
  --outline-button--secondary-bg-color--computed:var(
    --outline-button--secondary-bg-color,
    var(--brand-dark-blue-900)
  );
  --outline-button--secondary-color--computed:var(
    --outline-button--secondary-color,
    var(--outline-white)
  );
  --outline-button--secondary-weight--computed:var(
    --outline-button--secondary-weight,
    var(--outline-button--weight--computed)
  );
  --outline-button--secondary-ring--computed:var(
    --outline-button--secondary-ring,
    var(--outline-ring-inset) 0 0 0 var(--outline-ring-offset-width)
      var(--outline-blue-600)
  );
  --outline-button--secondary-bg-color-focus--computed:var(
    --outline-button--secondary-bg-color-focus,
    var(--brand-dark-blue-900)
  );
  --outline-button--secondary-color-focus--computed:var(
    --outline-button--secondary-color-focus,
    var(--outline-white)
  );
  --outline-button--secondary-weight-focus--computed:var(
    --outline-button--secondary-weight-focus,
    var(--outline-button--weight--computed)
  );
  --outline-button--secondary-ring-focus--computed:var(
    --outline-button--secondary-ring-focus,
    2px solid var(--brand-dark-blue-900)
  );
  --outline-button--secondary-disabled-bg-color--computed:var(
    --outline-button--secondary-disabled-bg-color,
    var(--outline-white)
  );
  --outline-button--secondary-disabled-color--computed:var(
    --outline-button--secondary-disabled-color,
    var(--outline-gray-400)
  );
  --outline-button--secondary-disabled-weight--computed:var(
    --outline-button--secondary-disabled-weight,
    var(--outline-button--weight--computed)
  );
  vertical-align:middle;
  --outline-button-left-icon-container-margin-right:1.25rem;
  --outline-button-margin-left:0;
  --outline-button-right-icon-container-margin-left:1rem;
  --outline-button-rounded-border-radius:50%;
  --outline-button-rounded-width:54px;
  --outline-button-rounded-height:54px;
  --outline-button-left-icon-padding:0.4rem 2rem 0.4rem 0.4rem;
  --outline-button-extra-large-padding:1rem 2rem 1rem 0.4rem;
  --outline-button-font-family:var(--outline-button--family--computed);
  --outline-button-padding:var(--outline-button--padding--computed);
  --outline-button-accent-color:var(--brand-dark-blue-900);
  --outlne-button-icon-size:2rem;
}

.btn{
  display:inline-flex;
  flex-wrap:nowrap;
  align-items:center;
  cursor:pointer;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, outline, outline-color;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
  text-decoration-line:none;
  outline:none;
  border:none;
  letter-spacing:1px;

  line-height:1.5;
}

.btn.white{
    --outline-button-accent-color:var(--outline-white);
  }

.btn.dropdown{
    --outline-button-padding:6px 1rem;
    --outline-button-font-family:var(--ff-body);
    --outline-button-right-icon-container-margin-left:0.25rem;
    --outline-button-accent-color:var(--brand-dark-blue-900);
  }

.btn.has-droplet-icon{
    --outline-button-margin-left:-5px;
  }

.btn{

  border-radius:var(--outline-button--radius--computed);
  font-family:var(--outline-button-font-family);
  font-weight:var(--outline-button--weight--computed);
  padding:var(--outline-button-padding);
  margin-left:var(--outline-button-margin-left);
}

.left-icon-container{
  display:flex;
  align-items:center;
  justify-content:center;
  width:var(--outlne-button-icon-size);
  max-width:var(--outlne-button-icon-size);
  height:var(--outlne-button-icon-size);
  max-height:var(--outlne-button-icon-size);
  margin-right:var(--outline-button-left-icon-container-margin-right);
  border-radius:4px;
}

.left-icon-container.droplet{
  border-radius:0;
}

.right-icon-container{
  display:flex;
  align-items:center;
  justify-content:center;
  margin-left:var(--outline-button-right-icon-container-margin-left);
}

.btn[aria-disabled='true']{
  pointer-events:none;
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}

.btn.primary{
  padding:var(--outline-button--primary-padding--computed);
  border-radius:var(--outline-button--primary-radius--computed);
  background-color:var(--outline-button--primary-bg-color--computed);
  color:var(--outline-button--primary-color--computed);
  font-weight:var(--outline-button--primary-weight--computed);
  box-shadow:var(--outline-button--primary-ring--computed);
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.btn.primary .right-icon-container{
    transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

.btn.primary:hover{
    transform:scale(1.05);
  }

.btn.primary:hover .right-icon-container{
      transform:translateX(0.5rem);
    }

.btn.primary:focus{
    background-color:var(--outline-button--primary-bg-color-focus--computed);
    color:var(--outline-button--primary-color-focus--computed);
    font-weight:var(--outline-button--primary-weight-focus--computed);
    outline:2px solid var(--outline-button-accent-color);
    outline-offset:2px;
  }

.btn.primary.has-left-icon{
    padding:var(--outline-button-left-icon-padding);
  }

.btn.primary.has-left-icon .left-icon-container{
      color:var(--outline-white);
      background-color:var(--brand-dark-blue-900);
    }

.btn.primary.rounded{
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:var(--outline-button-rounded-border-radius);
    width:var(--outline-button-rounded-width);
    height:var(--outline-button-rounded-height);
    padding:0;
  }

.btn.primary.search-button{
    padding:0.375rem;
  }

.btn.primary.mobile{
    width:100%;
    justify-content:center;
  }

.btn.primary.extra-large{
    --outlne-button-icon-size:3.25rem;
    padding:var(--outline-button-extra-large-padding);
  }

.btn.secondary{
  padding:var(--outline-button--secondary-padding--computed);
  border-radius:var(--outline-button--secondary-radius--computed);

  background-color:var(--outline-button--secondary-bg-color--computed);
  color:var(--outline-button--secondary-color--computed);
  font-weight:var(--outline-button--secondary-weight--computed);
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.btn.secondary .right-icon-container{
    transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

.btn.secondary:hover{
    transform:scale(1.05);
  }

.btn.secondary:hover .right-icon-container{
      transform:translateX(0.5rem);
    }

.btn.secondary:focus{
    background-color:var(--outline-button--secondary-bg-color-focus--computed);
    color:var(--outline-button--secondary-color-focus--computed);
    font-weight:var(--outline-button--secondary-weight-focus--computed);
    outline:2px solid var(--outline-button-accent-color);
    outline-offset:2px;
  }

.btn.secondary.has-left-icon{
    padding:var(--outline-button-left-icon-padding);
  }

.btn.secondary.has-left-icon .left-icon-container{
      background-color:var(--brand-bright-blue-900);
      color:var(--brand-dark-blue-900);
    }

.btn.secondary.rounded{
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:var(--outline-button-rounded-border-radius);
    width:var(--outline-button-rounded-width);
    height:var(--outline-button-rounded-height);
    padding:0;
  }

.btn.secondary.mobile{
    width:100%;
    justify-content:center;
  }

.btn.primary[aria-disabled='true'],
.btn.secondary[aria-disabled='true']{
  background-color:var(--outline-button--primary-disabled-bg-color--computed);
  color:var(--outline-button--primary-disabled-color--computed);
  font-weight:var(--outline-button--primary-disabled-weight--computed);
}

.btn.link{
  font-family:var(--ff-display);
}

.btn.link.small-font{
    font-family:var(--ff-body);
  }

.btn.link.extra-small-font{
    font-family:var(--ff-body);
    font-size:var(--fs-sm);
  }

.btn.link{
  display:inline-flex;
  font-size:var(--outline-button--link-font-size--computed);
  padding:var(--outline-button--link-padding--computed);
  position:relative;
  border-radius:0;
  color:var(--outline-button--link-color--computed);
}

.btn.link.white{
    color:var(--outline-white);
  }

.btn.link{
  background-color:var(--outline-button--link-bg-color--computed);
}

.btn.link:before,
  .btn.link:after{
    content:'';
    position:absolute;
  }

.btn.link:after{
    background-color:var(--outline-button-accent-color);
    bottom:-0.25rem;
    height:0.25rem;
    left:0.5rem;
    transition:width 0.3s;
    width:0;
  }

.btn.link,
  .btn.link:visited,
  .btn.link:hover{
    color:var(--outline-button-accent-color);
  }

.btn.link,
  .btn.link:visited,
  .btn.link:hover,
  .btn.link:focus{
    outline:0;
    text-decoration:none;
  }

.btn.link:not(.search-button):not(.cta):hover:after{
        width:calc(100% - 1rem);
      }

.btn.link:not(.search-button):not(.cta):focus{
      background-color:var(--brand-dark-blue-900);
      color:var(--outline-white);
    }

.btn.link:not(.search-button):not(.cta):focus:before{
        background-color:var(--outline-white);
        border-top:4px solid var(--brand-dark-blue-900);
        height:8px;
        left:0;
        top:-8px;
        transition:none;
        width:100%;
      }

.btn.link:not(.search-button):not(.cta):focus:after{
        background-color:var(--outline-white);
        border-bottom:4px solid var(--brand-dark-blue-900);
        bottom:-8px;
        height:8px;
        left:0;
        transition:none;
        width:100%;
      }

.btn.link .left-icon-container{
    width:auto;
    height:auto;
    margin-right:var(--spacing-1);
  }

.btn.link .right-icon-container{
    margin-left:var(--spacing-1);
  }

.btn.link.cta{
    padding:5px 0;
    white-space:nowrap;
    letter-spacing:1px;
    line-height:1.11111;
  }

.btn.link.cta .right-icon-container{
      transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

.btn.link.cta:hover .right-icon-container{
        transform:translateX(0.5rem);
      }

.btn.link[aria-disabled='true']{
  background-color:var(--outline-button--link-disabled-bg-color--computed);
  color:var(--outline-button--link-disabled-color--computed);
  font-weight:var(--outline-button--link-disabled-weight--computed);
}

.btn.dropdown{
  border-radius:var(--outline-button--primary-radius--computed);
  background-color:var(--outline-button--primary-bg-color--computed);
  color:var(--outline-button--primary-color--computed);
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition:border-radius 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.btn.dropdown .right-icon-container{
    transition:transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

.btn.dropdown{
  letter-spacing:normal;
}

.btn.dropdown:before,
  .btn.dropdown:after{
    content:'';
    position:absolute;
  }

.btn.dropdown:after{
    background-color:var(--outline-button-accent-color);
    bottom:-3px;
    height:3px;
    left:0;
    transition:width 0.3s;
    width:0;
    z-index:999;
  }

.btn.dropdown,
  .btn.dropdown:visited,
  .btn.dropdown:hover{
    color:var(--outline-button-accent-color);
  }

.btn.dropdown.open .right-icon-container{
      transform:rotate(180deg);
    }

.btn.dropdown.open{
    border-radius:0.4rem 0.4rem 0 0;
}

.btn.dropdown.open:after{
      width:calc(100%);
    }

.btn.dropdown:focus-visible{
    background-color:var(--outline-button--primary-bg-color-focus--computed);
    color:var(--outline-button--primary-color-focus--computed);
    font-weight:var(--outline-button--primary-weight-focus--computed);
    outline:2px solid var(--outline-white);
    outline-offset:2px;
  }

.btn.dropdown .right-icon-container{
    margin-left:var(--spacing-3);
  }

.btn.dropdown.mobile{
    width:100%;
    justify-content:center;
  }

.outline-file-link{
  width:100%;
}

.outline-file-link .btn{
    width:100% !important;
  }
`;